import { foodImage, logo } from "@/assets";

const Template1 = ({ template, previewData }) => {
  const isStrictPreview = Boolean(previewData?.strictTablePreview);
  const backgroundImage = template?.image_url || foodImage;
  const logoImage = template?.logo_url || logo;
  const title = previewData?.title || (isStrictPreview ? "No provide" : "GIFT VOUCHER");
  const customerName =
    previewData?.customerName || (isStrictPreview ? "No provide" : "Md Rasel Mahmud");
  const code = previewData?.code || (isStrictPreview ? "No provide" : "32154232");
  const message = previewData?.message || (isStrictPreview ? "No provide" : "Happy Birthday");
  const templateNote = previewData?.template_note;

  return (
    <div className="flex items-center justify-center p-4">
      {/* Main Card Container */}
      <div
        data-export-capture="c2c-template"
        className="relative w-full max-w-2xl h-[300px] shadow-2xl overflow-hidden rounded-sm flex bg-black"
      >
        
        <div 
          className="w-[42%] h-full bg-cover bg-center border-r border-gray-900"
          style={{ backgroundImage: `url(${backgroundImage})` }}
        >
          <div className="w-full h-full bg-black/5"></div>
        </div>
        <div className="w-[58%] h-full flex flex-col justify-between text-white p-6 py-5 text-center relative">
          <div>
            <h1 className="text-xl font-bold uppercase tracking-wider mb-1 leading-none text-amber-400">
              {title}
            </h1>

            <div className="mb-2">
              <p className="text-base font-serif italic text-gray-200">
                {customerName}
              </p>
              <p className="text-[10px] font-sans tracking-wide text-gray-400">
                Code: {code}
              </p>
            </div>

            {previewData?.items && previewData.items.length > 0 ? (
              <div className="mb-2 w-full text-center px-2">
                <p className="text-[9px] uppercase tracking-widest text-amber-400/90 font-bold mb-0.5">GIFT ITEMS</p>
                <p className="text-[11px] text-gray-200 font-mono leading-tight">
                  {previewData.items.map((item) => {
                    const name = item?.menu_item?.name || item?.name || "";
                    const variant = item?.variant?.name ? ` (${item.variant.name})` : item?.variant_name ? ` (${item.variant_name})` : "";
                    return `${name}${variant}`;
                  }).join(", ")}
                </p>
              </div>
            ) : previewData?.reward ? (
              <div className="mb-2 px-3 py-0.5 bg-amber-500/20 border border-amber-500/30 rounded text-amber-300 font-bold text-sm inline-block">
                Value: £{previewData.reward}
              </div>
            ) : null}

            {templateNote ? (
              <p className="text-xs text-gray-300 font-sans leading-tight mt-1 px-4">
                {templateNote}
              </p>
            ) : null}
          </div>

          <div className="mt-auto border-t border-white/10 pt-2 w-full">
            <p className="text-base font-extralight italic tracking-tight text-white leading-none mb-1">
              {message}
            </p>
            <div className="flex justify-center mt-1">
              <img src={logoImage} alt="Logo" className="h-5 w-auto object-contain opacity-80" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Template1;